import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var FactionColors = {
  minmatar: "#FE3743",
  amarr: "#E7B815",
  gallente: "#37BA5B",
  caldari: "#00ACD1",
  angel: "#FFE1B0",
  guristas: "#FF7F00"
};
var FindFactionColor = function FindFactionColor(faction) {
  var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b;
  var lower = Object.fromEntries(Object.entries(_objectSpread(_objectSpread({}, FactionColors), override)).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      val = _ref2[1];
    return typeof val === "string";
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    return [key.toLowerCase(), val];
  }));
  return (_b = lower[(_a = faction == null ? void 0 : faction.toLowerCase()) != null ? _a : "unknown"]) != null ? _b : "#FFFFFF";
};
export { FactionColors, FindFactionColor };